module.exports = __webpack_public_path__ + "img/car2.6be907d3.svg";